import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import { apiCatalog } from "@/store/external-apis/types";
import { loadCatalogSwagger } from "@/store/external-apis/actions";

export default defineComponent({
  name: "sdk-api-catalog",
  components: {
    "sdk-api-controller": () => import("./sdk-api-controller/sdk-api-controller.vue"),
  },
  data() {
    return {
      controllers: {} as any,
      isLoading: false,
      loadError: false,
      errorMessage: "",
    };
  },
  computed: {
    ...mapGetters({
      apiCatalog,
    }),
    selectedController(): string {
      return this.$route.params.controllerName ? this.$route.params.controllerName : "";
    },
    controllersKeys(): string[] {
      return Object.keys(this.controllers);
    },
  },
  methods: {
    selectFirstController() {
      if (!this.selectedController) {
        this.$router.push({ name: "api-controller", params: { controllerName: this.controllersKeys[0] } });
      }
    },
    selectController(list: any) {
      this.$router.push({ name: "api-controller", params: { controllerName: list[0].name } });
      const container: HTMLElement = document.querySelector(".sdk-api-controller--api") as HTMLElement;
      if (container) {
        container.scrollTop = 0;
      }
    },
    mountControllers() {
      const controllerList = Object.keys(this.apiCatalog.paths);

      const result = controllerList.reduce((init: any, current: string) => {
        const controllerName = current.split("/")[1].replace(/-/g, " ");
        const controllerPath = current;

        init.push({ name: controllerName, path: controllerPath, info: this.apiCatalog.paths[controllerPath] });

        return init;
      }, []);

      this.groupController(result, "name");
    },
    groupController(list: [], property: string) {
      const groups = list.reduce((arr: any, obj: any) => {
        const key = obj[property];
        if (!arr[key]) {
          arr[key] = [];
        }
        arr[key].push(obj);
        return arr;
      }, {});

      this.controllers = groups;
    },
    loadSwaggerInfo() {
      this.isLoading = true;
      this.$dispatch(loadCatalogSwagger)([])
        .then(() => {
          this.mountControllers();
          this.selectFirstController();
        })
        .catch((err: any) => {
          this.loadError = true;
          this.errorMessage = err[0];
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  mounted() {
    this.loadSwaggerInfo();
  },
});
